import { useQuery } from 'data-fetching-client';
import { GET_LISTING_DETAILS_V1_QUERY } from '../../__generated__/chirp/com/hubspot/marketplace/listing/details/rpc/MarketplaceListingDetailsRpc.dfc.new';
export function useUnifiedDetails({
  slug,
  language,
  skip
}) {
  var _unifiedDetailsData$r, _previousUnifiedDetai;
  const variables = language ? {
    slug,
    language
  } : {
    slug
  };
  const {
    data: unifiedDetailsData,
    loading: unifiedDetailsLoading,
    error: unifiedDetailsError,
    previousData: previousUnifiedDetailsData
  } = useQuery(GET_LISTING_DETAILS_V1_QUERY, {
    variables,
    skip
  });
  const parsedUnifiedDetailsData = JSON.parse((unifiedDetailsData === null || unifiedDetailsData === void 0 || (_unifiedDetailsData$r = unifiedDetailsData.result) === null || _unifiedDetailsData$r === void 0 ? void 0 : _unifiedDetailsData$r.listing) || '{}');
  const parsedPreviousUnifiedDetailsData = JSON.parse((previousUnifiedDetailsData === null || previousUnifiedDetailsData === void 0 || (_previousUnifiedDetai = previousUnifiedDetailsData.result) === null || _previousUnifiedDetai === void 0 ? void 0 : _previousUnifiedDetai.listing) || '{}');
  return {
    unifiedDetailsData: parsedUnifiedDetailsData,
    previousUnifiedDetailsData: parsedPreviousUnifiedDetailsData,
    unifiedDetailsLoading,
    unifiedDetailsError
  };
}